export const Button = ({
  children,
  onClick,
  href,
  type = "button",
  variant = "primary",
  className = "",
}) => {
  const baseStyles =
    "font-heading inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold transition-all duration-200 focus:outline-none no-underline";

  const variants = {
    primary: "bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm",

    secondary:
      "bg-white border border-indigo-600 text-indigo-600 hover:bg-indigo-600 hover:text-white shadow-sm",

    subtle: "text-gray-700 hover:bg-gray-100",
  };

  const combined = `${baseStyles} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={combined}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={combined}>
      {children}
    </button>
  );
};
